export const FETCHING_COMMITMENT = "FETCHING.COMMITMENT";
export const SIGNING_COMMITMENT = "SIGNING.COMMITMENT";
export const FETCHED_COMMITMENT = "FETCHED.COMMITMENT"; 
export const SIGNED_COMMITMENT = "SIGNED.COMMITMENT"; 
export const ERROR_FETCHING_COMMITMENT = "ERROR.FETCHING_COMMITMENT";
 